"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaFromTypedModel = void 0;
const convertTypedModel_1 = require("./getValidationErrors/convertTypedModel");
const getSchemaFromTypedModel = (schema) => {
    const item = schema;
    if (typeof item !== 'function')
        return item;
    if (!(0, convertTypedModel_1.isClass)(item))
        return item;
    if (!item.getModel || !item.__schemaId)
        return item;
    return item.getModel().getCleanSchema();
};
exports.getSchemaFromTypedModel = getSchemaFromTypedModel;
